var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dv-chip state-vfx-chip",attrs:{"title":_vm.boundBlowName}},[_vm._v(_vm._s(_vm.chipName)+" "),_c('span',{staticClass:"id"},[_vm._v("#"+_vm._s(_vm.stateEffectId))])])}
var staticRenderFns = []

export { render, staticRenderFns }